import Vue from 'vue'
import Vuex  from 'vuex'
Vue.use(Vuex)

const state = {
  userInfo:window.localStorage.userInfo?JSON.parse(window.localStorage.userInfo):{},
}

const mutations = {
  //获取用户信息
  getUserInfo(state,userInfo){
    state.userInfo = userInfo;
  },
}

const actions = {
  userInfoAction(context,userInfo){
      context.commit('getUserInfo',userInfo);
  },
}
export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js